import { nativeJSBridge, nativeJSBridgeSync } from './nativeJSBridge'
import { IStorage, IBridgeOptions } from './interface'

/**
 * 删除本地数据
 *
 * @param {IBridgeOptions<IStorage>} {
 *   key,
 *   scope,
 *   domain,
 *   multi_param,
 *   success,
 *   fail,
 *   complete
 * }
 */
function removeStorageSync({
  key,
  scope,
  domain,
  multi_param,
  success,
  fail,
  complete
}: IBridgeOptions<IStorage>) {
  const params = {
    key,
    scope,
    domain,
    multi_param
  }
  const opts = {
    method: 'native.deleteData',
    params,
    success,
    fail,
    complete
  }
  try {
    nativeJSBridgeSync(opts)
  } catch (error) {
    console.log('removeStorageSync error: ', error)
  }
}

/**
 * 删除本地数据
 * 一个异步接口，支持 Promise 化使用
 * @param {IBridgeOptions<IStorage>} { key, scope, domain, multi_param }
 * @returns
 */
function removeStorage({ key, scope, domain, multi_param }: IBridgeOptions<IStorage>) {
  const params = {
    key,
    scope,
    domain,
    multi_param
  }
  const opts = {
    method: 'native.deleteData',
    params
  }

  return nativeJSBridge(opts)
}

export { removeStorage, removeStorageSync }
